import { getRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

const getSportsDbLeagues = async (sport) => {
  try {
    const { response, logComplete } = await getRequest('sportsDbLeagues', { sport })
    logComplete()
    return response
  } catch (error) {
    logger.error('getSportsDbLeagues', error)
    throw error
  }
}

export { getSportsDbLeagues }
